(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-footer"]) return;
  try {
    
  (function () {
    var FORM_ID = 'SJmu9D';

    function applyInputStyles(container) {
      var input = container.querySelector('input[type="email"], input[type="text"]');
      var button = container.querySelector('button[type="submit"], button');
      if (!input && !button) return false;

      if (input) {
        Object.assign(input.style, {
          background: 'transparent',
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          color: '#fff',
          fontSize: '0.875rem',
          padding: '10px 14px',
          borderRadius: '0',
        });
      }

      if (button) {
        Object.assign(button.style, {
          background: 'transparent',
          border: 'none',
          color: '#fff',
          cursor: 'pointer',
          borderRadius: '0',
          boxShadow: 'none',
        });
      }

      return !!(input || button);
    }

    /* Watch for Klaviyo state changes (loading → CAPTCHA / success).
       When Klaviyo injects a CAPTCHA or success screen it replaces or
       overlays the <form> with a full-width block. We must remove the
       flex-row constraint from the outer container so it renders properly. */
    function watchContainer(container) {
      var observer = new MutationObserver(function () {
        var form = container.querySelector('form');
        var btn  = container.querySelector('button[type="submit"], button');

        /* Detect loading state: button gains aria-busy or a loading/spinner
           sibling element appears inside the container */
        var spinner = container.querySelector(
          '[data-testid="spinner"], [class*="spinner"], [class*="loading"], svg[class*="spin"]'
        );
        var isLoading = spinner ||
          (btn && (btn.getAttribute('aria-busy') === 'true' ||
                   btn.getAttribute('data-loading') === 'true' ||
                   btn.disabled));

        /* Hide submit arrow while loading */
        if (btn) {
          btn.style.visibility = isLoading ? 'hidden' : '';
        }

        /* If <form> is gone, Klaviyo is showing success / CAPTCHA.
           Switch container from row-flex to block so the injected
           content can render at full width. */
        if (!form) {
          container.style.display = 'block';
          container.style.flexDirection = '';
          container.style.alignItems = '';
        } else {
          /* Re-apply cosmetic styles after Klaviyo re-renders */
          applyInputStyles(container);
        }
      });

      observer.observe(container, { childList: true, subtree: true, attributes: true });
    }

    function init() {
      var container = document.querySelector('.klaviyo-form-' + FORM_ID);
      if (!container) return;

      var attempts = 0;
      var max = 40;
      var timer = setInterval(function () {
        if (container.children.length > 0) {
          clearInterval(timer);
          applyInputStyles(container);
          watchContainer(container);
        } else if (++attempts >= max) {
          clearInterval(timer);
        }
      }, 300);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-cards"]) return;
  try {
    
  (function () {
    var BREAKPOINT = 750;

    function initSwiper(swiper) {
      var track = swiper.querySelector('.pw-cards');
      var cards = Array.from(track ? track.querySelectorAll('.pw-card') : []);
      var prevBtn = swiper.querySelector('.pw-cards-nav__btn--prev');
      var nextBtn = swiper.querySelector('.pw-cards-nav__btn--next');

      if (!track || cards.length === 0 || !prevBtn || !nextBtn) return;

      var currentIndex = 0;

      function scrollToCard(index) {
        currentIndex = Math.max(0, Math.min(index, cards.length - 1));
        var card = cards[currentIndex];
        var offset = card.offsetLeft - (track.offsetWidth - card.offsetWidth) / 2;
        track.scrollTo({ left: Math.max(0, offset), behavior: 'smooth' });
        updateButtons();
      }

      function updateButtons() {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === cards.length - 1;
      }

      prevBtn.addEventListener('click', function () {
        scrollToCard(currentIndex - 1);
      });

      nextBtn.addEventListener('click', function () {
        scrollToCard(currentIndex + 1);
      });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var center = track.scrollLeft + track.offsetWidth / 2;
          var closest = 0;
          var closestDist = Infinity;
          cards.forEach(function (card, i) {
            var cardCenter = card.offsetLeft + card.offsetWidth / 2;
            var dist = Math.abs(cardCenter - center);
            if (dist < closestDist) {
              closestDist = dist;
              closest = i;
            }
          });
          if (closest !== currentIndex) {
            currentIndex = closest;
            updateButtons();
          }
        }, 80);
      });

      updateButtons();
    }

    function setup() {
      if (window.innerWidth >= BREAKPOINT) return;
      document.querySelectorAll('.pw-cards-swiper').forEach(function (swiper) {
        if (swiper.dataset.swiperReady) return;
        swiper.dataset.swiperReady = '1';
        initSwiper(swiper);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
